// import { Group } from './lib/Group';
import { Group2 } from './lib/Group2';

export * from './lib/components';
export * from './lib/hooks';
// export default Group;
export default Group2;
